import {
  FeedMappingRule,
  LocationFeed,
  RemoteFeedMappingRule,
  RemoteLocationFeed,
} from './locationFeed.types';
import {DateTime} from 'luxon';
import getFeedRuleType from './utils/getFeedRuleType';

function toClientLocationFeed(remoteFeed: RemoteLocationFeed): LocationFeed {
  return {
    ...remoteFeed,
    lastUploadDate: DateTime.fromISO(remoteFeed.lastUploadDate),
    ...(remoteFeed.createTime && {createTime: DateTime.fromISO(remoteFeed.createTime)}),
    mapping: {
      ...remoteFeed.mapping,
      rules: remoteFeed.mapping?.rules?.map(toClientMappingRule) || [],
    },
    campaignsIds: remoteFeed.campaignsIds ?? [],
  };
}

function toClientMappingRule(rule: RemoteFeedMappingRule): FeedMappingRule {
  const lowercaseKeyValue = ({Key: key, Value: value}: {Key: string; Value: string}) => ({
    key,
    value,
  });

  return {
    ...rule,
    replace: rule?.replace?.map(lowercaseKeyValue) || null,
    regexReplace: rule?.regexReplace?.map(lowercaseKeyValue) || null,
    ruleType: getFeedRuleType(rule),
  };
}

function toRemoteMappingRule(rule: FeedMappingRule): RemoteFeedMappingRule {
  const capitalizeKeyValue = ({key: Key, value: Value}: {key: string; value: string}) => ({
    Key,
    Value,
  });

  return {
    ...rule,
    replace: rule?.replace?.map(capitalizeKeyValue) || null,
    regexReplace: rule?.regexReplace?.map(capitalizeKeyValue) || null,
  };
}

function toRemoteMapping(mapping: LocationFeed['mapping']): RemoteLocationFeed['mapping'] {
  return {
    ...mapping,
    rules: mapping.rules.map(toRemoteMappingRule),
  };
}

export {toClientLocationFeed, toClientMappingRule, toRemoteMappingRule, toRemoteMapping};
